import { useEffect, useState } from 'react';
import { getProductLicenceInformation } from '@/features/games-app/shared/api/get-product-licence-information';
import { ProductLicenseInfo } from '@/features/games-app/shared/types/licensing.types';
import { useIsWTGamesApp } from '@/features/games-app-bridge/shared/hooks/use-is-wt-games-app';

function productHasTrials(productLicenseInfo: ProductLicenseInfo | undefined) {
  //We only get product license info, when someone installed the game until that we assume they have trials left
  if (!productLicenseInfo) return true;
  return productLicenseInfo.TrialSessionLeft !== '0';
}

export function useHasTrialsLeft(sku: string) {
  const isWTGamesApp = useIsWTGamesApp();
  const [trialsLeft, setTrialsLeft] = useState(() => !isWTGamesApp);
  const [loading, setLoading] = useState(() => isWTGamesApp);

  useEffect(() => {
    let aborted = false;

    if (!isWTGamesApp) {
      return;
    }
    (async () => {
      try {
        setLoading(true);
        const info = await getProductLicenceInformation(sku);
        if (!aborted) {
          setTrialsLeft(productHasTrials(info));
          setLoading(false);
        }
      } catch (e) {
        //We first get product license info, when someone installed the game until that we assume they have trials left
        console.error('license info fetch failed', e);
        if (!aborted) setTrialsLeft(true);
        setLoading(false);
      }
    })();
    return () => {
      aborted = true;
    };
  }, [isWTGamesApp, sku]);

  return {
    trialsLeft: isWTGamesApp ? trialsLeft : true,
    loading: isWTGamesApp ? loading : false,
  };
}
